import piexif from 'piexifjs';

export const removeGPSMetadata = async (blob: Blob): Promise<Blob> => {
  if (blob.type !== 'image/jpeg') {
    return blob;
  }

  const imageDataURL = await new Promise<string | null>((resolve) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      if (!e.target || e.target.error) {
        resolve(null);
        return;
      }

      resolve(e.target.result as string);
    };

    reader.readAsDataURL(blob);
  });

  if (!imageDataURL) {
    return blob;
  }

  const exifObj = piexif.load(imageDataURL);
  delete exifObj.GPS;
  const imageDataWithoutExif = piexif.remove(imageDataURL);
  const imageDataWithoutGPS = piexif.insert(piexif.dump(exifObj), imageDataWithoutExif);

  return (await fetch(imageDataWithoutGPS)).blob();
};
